export function galleryImagePageUrl(image: { displayOrder: string | number }, gallery: { path: string }) {
  return [gallery.path, 'image', `${image.displayOrder}`].join('/');
}
